export default {
  forSale: false,
  viewable: true,
  title: 'Áfangi AB',
  key: 'afangi-ab',
  rect: {
    className: 'bg-dark text-white',
    props: {
      transform: 'translate(4320, 2380) scale(0.7)',
      width: 460,
      height: 130,
    },
  },
  path: {
    d: 'M4599.21 2415.76l-3.62-4.66-10.08-8.32-69.56-56.1 2.86-47.92-24-16.88.24-5.22-22-59.09-16.5 1.5-14-28.5-109 9.32-7-4.93 1.07-25.92h4.93l.22-13.4-9.54-7.39.94-15-19-55.84-27.88 2.81-10.37-25-91.85 8.51v-26.83l-20.73-15.11v-5.15l-16.07-50.46-12.53.8-8.36-20.89-101.38 8.82-70.56-54.64-20-33.7h-21.22v-27.86h4.29l.64-11.14-8.35-6.21v-13.66l-11.9-44.36-20.41 1.45-6.43-14.31-94.82 7.07-6.43 5.63-45.64-38.73v-9.81h13.34l.8-11.41-13.34-9.8-.8-16.07-14.46-11.09v-12.06l-23.79-43.55-86.79 5.63-29.89-25.24-10.77-8.51-14.62-8.84v-12.86l-19.93-37.61-30.7 1-16.39-1.93-32.62-2.57L3399 1516l-11.9-4.34v-34.07l-22.5-21.7-14.14-12.32-65 14.89-40.28 8.68v33.32l-19.72 4.5-13.17-19.28-41.79 8.89c-.11.32-19.18 14.68-19.18 14.68s.54 15.54 0 15.64l-7.28 1.4v-5.36l-16.29-27.11-63.64 13.39-16.66 13-2.09 1.63V1537l-2 .7-7.94 2.73h0l-.53 55-137.57 38.79v-20.72l-26.37-27.77h0l-10-10.48-36.4 7.81-72.8 15.63-14.27 3.57-21.33 5.35v21.21h0v29.89l5.2 2.15-.11 23.14-85.88 26.41 24.7 9.7 87.75 43.39 117 56.89 118.61 60.75 134.58 65.57 150.43 73.72 190.28 96.43 156 71.57 107.58 51 91.71 42.86 89.14 39.85s48 16.29 49.29 17.57 88.28 33.86 97.28 36.43 85.72 21.86 85.72 21.86l122.14 24 110.36 10.5 54.21 3.43 67.29-1.72 54 3.22 35.57 2.78 5.14-1.07 5.79-1.93 4.46-1.88 4.06-2.54 2.41-2.77.88-4.94v-4.74z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/sementsreitur/T-AB.jpg'),
      width: 5272,
      height: 2962,
    },
    list: [
      {
        lod: 'B9-10',
        d: 'M2145.11 917.79l-5.71-60.67-8.11-17.68-4.5-41.39-47.47-126.37-21.53-9.54-56.47-25.6-66.75 61.39v4.93l-81.16-34.26-64.42 60.86.48 6.48-2.76.56 6.86 51.86-89.36 4.5-62.35 13.71-106.29 21.86-12.86-49.93-82.15-12.56-82.15-12.56-51.08 28.25-92.33 51.08 2.14 14.04h-80.35l89.67 468.32 315.11-65.78 130.29-28.93 385.98-90.75 101.41-24.11 44.68-14.3-58.82-173.41z',
      },
      {
        lod: 'B7-8',
        d: 'M2449.18 1798.71l-5.47-131.14-17.89-45.21-1.61-38.47-67.92-190.55-52.72-20.73-87.59-245.09-33.27 9.16-.64 30.7-79.39-30.7-69.75 59.78-65.25 13.18-20.57-6.43-15.27 12.7-181.13 37.02-15.64 5.57 47.14 194.57-87 16.93 20.58 95.14-115.34 22.18-145.24-9.43-114.1 60.22-92.63 19.77 37.98 437.56 600.97-131.73 321-73.71 252-59.14-11.25-32.15z',
      },
      {
        lod: 'B6',
        d: 'M1248.48 1657.88l-224 45.32-438.06-109-49 10.71-30.75-59.78-224-14.79L113 1623l-44 331.82 40.82 61.29L78 2360.68l7.07 5.14h26c1.28 0 148.5-34.39 148.5-34.39l264.53-59.79 298.29-67.5 453-106.28 11-2.42z',
      },
      {
        lod: 'B4-5',
        d: 'M699 383.41l-67.5-7.87-132.43 56.41-17.19-40.5-168.11-29.09L186 435l-21 130.71 52.18 107.79h5.14l19.77 42.27-5.79 4.98-11.19 89.79 9.96 18.96-42.96-13.71-59.36 62.57-21.64 145.5 19.36 36.8-2.65 23.3 65.57 124.08-5.78 59.14 6.75 5.46 215.35 10.29 290.79-49.07-4.71-443.15 3.21-407.3z',
      },
      {
        lod: 'B3',
        d: 'M1073.79 420.21l-10.93-34.07L921 328.71l-116.41 42.65-19.13 25.87-58.33-8.03-28.13-5.79-3.21 407.3L1008 844.07l104.76-199.02-7.26-25.98 88.77-139.34 13.02-9.59 17.73-36.1-151.23-13.83z',
      },
      {
        lod: 'B2',
        d: 'M1527.07 795.41l99.25-238.75-3.05-16.39 12.05-24.27-8.52-53.36-40.66-5.3-79.23-9-81.32-10.61-58.98-1.77-141.59-1.92-17.73 36.1-13.02 9.59-88.77 139.34 7.26 25.98L1008 844.07l128.79 2.68h80.35l-2.14-14.04 92.33-51.08 51.08-28.25 82.15 12.56 82.15 12.56 4.36 16.91z',
      },
      {
        lod: 'B1',
        d: 'M1535.57 828.43l106.29-21.86 62.35-13.71 89.36-4.5-6.86-51.86 2.76-.56-.48-6.48 64.42-60.86 81.16 34.26v-4.93l66.75-61.39 56.47 25.6-53.58-159-21.42-1.93 12.85-33.64-24.21-.21-9-60.43-10.72-.86-4.28-30.43-142.07-58.71-124.88 42.53-53.68 103.18 8.52 53.36-12.05 24.27 3.05 16.39-99.25 238.75-4.36-16.91-82.15-12.56 82.15 12.56 12.86 49.93z',
      },
      {
        lod: 'A8',
        d: 'M4928.36 993l-220.61 6.11-79.82-69-80.79 58.87-74.73-76.82-88.55 79.55-4.02 11.25-279.32-1.28 86.62 112.02 63.86 91.87 123.99 171.74 133.15-32.45 103.07-30 113.58-36.22 92.35-25.07 67.5-26.78 40.07-22.5 40.29-30.22 56.57-47.36 46.93-50.57L4928.36 993z',
      },
      {
        lod: 'A7',
        d: 'M4251 1205.57l-63.86-91.87-86.62-112.02-687.38 9.64 125.04 173.57 211.18 349.82 229.18-60.53 147.53-36.32 141.75-34.72 94.82-22.82 12.35-3.01L4251 1205.57z',
      },
      {
        lod: 'A6',
        d: 'M3373.39 1014.54l111.43 161.67 29.25 47.23 193.07 320.27-796.07 188.58-255.86-583.18 718.18-134.57z',
      },
      {
        lod: 'A5',
        d: 'M2849.14 533.04l1.82-89.58-62.14-67.17-66.43 55.6-69.21-53.78-67.82 45.64-20.15 99.96h-175.5l163.15 388.1 417.57 49.9 38.54-407.79-159.83-20.88z',
      },
      {
        lod: 'A4',
        d: 'M3409.18 590.14l.11-9.43-136.72-59.46-153.75 43.39.11 3.65-109.96-14.37-38.54 407.79 376.93 11.79 78-20.36 85.82 1.61 24.1.45-11.22-358.35-114.88-6.71z',
      },
      {
        lod: 'A3',
        d: 'M4082.57 867.21l-25.25-233.41-106.43-6.91-12.53-87.96-52.93-68.14-86.36 59.57-2.14-20.15-60.22-51.42-80.08 43.71-14.31 101.25-118.26-6.9 11.22 358.35 182.26 3.41 189.64 6.1 181.61 9.22-6.22-106.72z',
      },
      {
        lod: 'A2',
        d: 'M4666.71 859.71l-61.05-186.26-84.23-3.59-38.41-120.59-43.39-63.32-95.95 60.91-2.89-7.56-54-50.62-86.15 43.55-31.98 108.81-111.34-7.24 25.25 233.41 6.22 106.72 312.43 2.19 71.19-63.96 61.74 63.47 34.06-2 59.72-43.52 41.32 35.72 6.06-.24-8.6-105.88z',
      },
      {
        lod: 'A1',
        d: 'M5251.39 750.64l-11.57-12.37-13.39-10.34-11.57-6.22-12.22-6.21-15.21-4.93-23.14-3.43-70.72-6.43-18-40.92-63.75-118.29-103.79 60-11.01-23.14-50.95-50.47-94.18 44.36-21.21 55.93 9.32 22.18-66-3.86-11.79 29.36-56.55-2.41 61.05 186.26 8.6 105.88 264.62-10.3 73.5 56.57 26.36 14.14 56.57 24.86 61.71-72.65 39.22-62.78 42-79.07 21.53-71.15-9.43-14.57z',
      },
    ],
  },
}
